// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__l725v","content":"Footer_content__6TGIZ"};